// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".password-wrapper[data-v-1c7ad3b0]{position:relative}.show-password-icon[data-v-1c7ad3b0]{position:absolute;right:0;top:14px;cursor:pointer}.show-password-icon.active[data-v-1c7ad3b0]{font-weight:600}.sign-in-btn[data-v-1c7ad3b0]{width:100%}.sign-up-link[data-v-1c7ad3b0]{text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
